
import ChecklistContainer from "./components/ChecklistContainer";
import "./index.css";

const Checklists = () => {
    return (
        <div className="Checklists">
            <ChecklistContainer />
        </div>
    );
};

export default Checklists;
